import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { api } from "@/lib/api";
import { fmtP } from "@/lib/jackpot";
import { UserAvatar, UserLink } from "@/components/UserBits";

const MEDAL = ["from-amber-200 to-amber-500 text-[#4a2a08]", "from-slate-100 to-slate-400 text-slate-800", "from-orange-300 to-orange-600 text-orange-950"];

function Row({ x, me }) {
  return (
    <li className={`flex items-center gap-3 rounded-2xl px-2.5 py-2 ${me ? "bg-amber-300/10 ring-1 ring-amber-300/40" : ""}`} data-testid={`jr-doubler-${x.rank}`}>
      <span className={`shrink-0 w-7 h-7 rounded-full text-xs font-black flex items-center justify-center ${x.rank <= 3 ? `bg-gradient-to-br ${MEDAL[x.rank - 1]}` : "bg-white/10 text-white/70"}`}>{x.rank}</span>
      <UserAvatar userId={x.user_id} name={x.name} picture={x.picture} size="w-9 h-9" text="text-xs" crown={false} />
      <UserLink id={x.user_id} className="flex-1 min-w-0 truncate text-sm font-bold text-white">{x.name}{me ? " (du)" : ""}</UserLink>
      <span className="text-right leading-tight">
        <span className="block font-display text-base font-black jr-gold-text tabular-nums">×2 · {x.doubles}</span>
        <span className="block text-[10px] text-white/50 tabular-nums">bis {fmtP(x.best)}</span>
      </span>
    </li>
  );
}

export function DoublersBoard({ live, tick }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get("/jackpot/doublers").then(({ data }) => setD(data)).catch(() => {});
    load();
    if (!live) return undefined;
    const i = setInterval(load, 10000);
    return () => clearInterval(i);
  }, [live, tick]);
  if (!d) return null;
  const meOutside = d.me && d.me.rank > d.top.length;
  return (
    <section className="rounded-[1.75rem] jr-panel p-5 sm:p-6" data-testid="jr-doublers">
      <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-amber-300/90">Rad-Rangliste</p>
      <h2 className="font-display text-lg font-extrabold text-white mt-1 flex items-center gap-2"><Crown className="w-5 h-5 text-amber-300" /> Die meisten Verdopplungen</h2>
      {d.top.length === 0 ? <p className="mt-3 text-sm text-white/50" data-testid="jr-doublers-empty">Noch hat niemand verdoppelt – wer landet als Erstes auf ×2?</p> : (
        <ol className="mt-3 space-y-1">{d.top.map((x) => <Row key={x.user_id} x={x} me={d.me?.user_id === x.user_id} />)}</ol>
      )}
      {meOutside && <ol className="mt-2 pt-2 border-t border-white/10" data-testid="jr-doublers-me"><Row x={d.me} me /></ol>}
    </section>
  );
}
